import { isRemovedRateAlias, rateTypeDisplayLabel } from 'src/utils/rateTypeIdentity';
import React from 'react';
import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import { SavedQuoteRateTypeOption } from './updateQuote/savedQuoteRateTypes';

export const unresolvedClientRate = (value: string, options: SavedQuoteRateTypeOption[]) =>
  isRemovedRateAlias(value) || !options.some(option => option.value === value && !option.disabled && !isRemovedRateAlias(option.value));

export default function BoundClientRateSelect({ value, onChange, options = [] }: {
  value: string; onChange: any; options?: SavedQuoteRateTypeOption[];
}) {
  const unresolved = unresolvedClientRate(value, options);
  return <FormControl size="small" fullWidth error={unresolved}>
    <Select variant="standard" name="rateType"
      value={value || ''} onChange={onChange}
      inputProps={{ 'aria-label': 'Rate Type' }} sx={{ fontSize: '14px' }}>
      {options.filter(option => !option.disabled && !isRemovedRateAlias(option.value)).map(option =>
        <MenuItem key={option.value} value={option.value}>{rateTypeDisplayLabel(option.value, option.label)}</MenuItem>)}
      {value && unresolved && <MenuItem value={value} disabled>{rateTypeDisplayLabel(value, options.find(option => option.value === value)?.label)} — needs review</MenuItem>}
    </Select>
    {unresolved && <FormHelperText>Choose a bound Agreement rule, or retain entered values for review.</FormHelperText>}
  </FormControl>;
}
